import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import color from '../shared/color'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import {ChoroplethUS, DonutChart, ScatterPlot, ThresholdBarChart} from '../d3'
import { Typography, Divider, Grid, CircularProgress, Paper} from '@material-ui/core'
import '../story.css'

function ESETAntiVirus() {

    const [title] = useState("ESET AntiVirus on MMS Devices")
    const [summary] = useState("Tracking of MMS Devices on each version of the ESET AntiVirus Application")
    const [categories] = useState(["security", "risk"])
    const [isLoading, setIsLoading] = useState(true)
    const [table1Layout, setTable1Layout] = useState(null)
    const [table2Layout, setTable2Layout] = useState(null)
    const [data, setData] = useState({})
    useEffect(() => {
        setTable1Layout([
            {column:"Application Name", field:"Application"},
            {column:"Version", field: "Version"},
            {column:"High Level Version", field: "HighLevelVersion"},
            {column:"Device Counts", field: "DeviceCounts"}
        ])
        setTable2Layout([
            {column:"Application Name", field:"Application"},
            {column:"Device Type", field: "devicetype"},
            {column:"Version", field: "Version"},
            {column:"Device Counts", field: "DeviceCounts"}
        ])
            async function fetch() {
                //Read the data
                await API.get('qs-web-api', '/data/esetantivirus/esetantivirus.json', {})
                    .then((storyData) => {
                        setData(storyData)
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
                setIsLoading(false)
            }
            fetch()
    }, [])
    if (isLoading) {
            return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
        } else {
            return (
                <div id="story">
                    <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>
                    <Paper className="storySection">
                        <Grid container justify="center" spacing={2} alignItems="stretch">
                            <div className="subText">
                                <Typography>
                                    ESET Endpoint Antivirus is an application found in MMS Devices with application version ranging from 5.0
                                    to 8.0. This article focuses on tracking the number of devices on each version of the application.
                                    By default only online, non-deleted, production status live MMS devices are reported here.
                                </Typography>
                            </div>
                        </Grid>
                    </Paper>
                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Trend of Device Counts on Each Version
                            </Typography>
                        </div>
                    </Grid>
                     <Grid container justify="center" spacing={2} alignItems="stretch">
                            <div className="subText">
                                <Typography>
                                    More than 99% of the MMS Devices have one of the 3 versions (5.0, 7.1 or 7.3).
                                    These high level version numbers are obtained by rounding the application version to the nearest 1 decimal place.
                                    The below graph shows the number of devices on each version since November 2020.
                                    Number of devices found with version 5.0 has been reducing, whereas 7.3 is increasing steadily.
                                </Typography>
                            </div>
                        </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterVersionsTrend} axis={{x: "Data Extracted Date", y: "# of MMS Devices"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.trendyrange} tooltip = {"Device Counts: "}
                                     colors = {["#F28E2C","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                </Paper>
                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Count of MMS Devices in every version of the ESET Endpoint Antivirus Application
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                The below count of devices is from a snapshot of devices with the ESET Endpoint Antivirus application
                                on the 1st day of this month. This article is planned to be refreshed on the first every month.
                                Majority of the devices have one of the 3 versions.
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutVersions} colors={color.defaultScheme} tooltip={"Number of Devices: "}
                            width={950} height={400} radius={200}></DonutChart>
                    </Grid>
                </Paper>
                <Paper className="storySection">
                <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="description">
                        <Typography variant="h6" fontWeight="bold">
                            Detailed Application Version Numbers and Device Counts
                        </Typography>
                    </div>
                </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                The below table shows the detailed version number of the applications and the count of
                                MMS devices in each of the version. The source of data for this article is RSS, device information.
                            </Typography>
                        </div>
                    </Grid>
                <StoryTable data={data.tableVersions} layout={table1Layout}></StoryTable>
                </Paper>
                <Paper className="storySection">
                <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="description">
                        <Typography variant="h6" fontWeight="bold">
                            Count of Devices by Device Type and High Level Application Version
                        </Typography>
                    </div>
                </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                MMS devices are identified based on the device type information in RSS.
                                Counts of devices for about 68 device types and their high level ESET application version information is available in the below table.
                            </Typography>
                        </div>
                    </Grid>
                <StoryTable data={data.tableDeviceTypes} layout={table2Layout}></StoryTable>
                </Paper>
            </div>
        )
    }
}
export default ESETAntiVirus
